import React from "react";

const Chapter5 = () => {
  return (
    <>
      <h2>Are CECs regulated pollutants?</h2>
      <p>
        EPA uses the 1985{" "}
        <a
          href="https://www.epa.gov/wqc/guidelines-deriving-numerical-national-water-quality-criteria-protection-aquatic-organisms-and"
          target="_blank"
          rel="noreferrer"
        >
          Guidelines for Deriving Numerical National Water Quality Criteria
        </a>{" "}
        and the 2008 Aquatic Life Criteria for Contaminants of Emerging Concern
        when considering applying standards for CECs. Recent technology has been
        able to detect CECs in small concentrations in our environmental waters,
        and they will require further study before Regulations and Standards are
        created.
      </p>
      <p>
        The State of Colorado has adopted water quality standards for many
        pesticides and other organic chemicals, including Nonylphenol, an
        endocrine disruptor.
      </p>
    </>
  );
};

export default Chapter5;
